export const initialState = {
    peopleList: [],
    userList: [],
    peopleDetails: {},
    peopleSortableList: [],
    selectedView: 'gridView'
};

const state = { ...initialState };

export default state;